module.exports = __webpack_public_path__ + "static/img/xzz.349af0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/xzz.jpg
// module id = Yo90
// module chunks = 1